// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-search-files[data-v-25cb42be] {
  height: 100%;
  overflow-y: auto;
}
.media-search-files[data-v-25cb42be] > :last-child {
  margin-bottom: 20px;
}
.media-search-files .months-name[data-v-25cb42be] {
  display: flex;
  justify-content: center;
  font-weight: 500;
  margin: 8px auto;
}
.media-search-files .files-wrapper[data-v-25cb42be] {
  display: flex;
  position: relative;
  flex-direction: column;
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] {
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 16px;
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message {
  display: grid;
  grid-template-columns: 50px minmax(50px, auto);
  padding-top: 0px;
  height: 48px;
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message:hover {
  background-color: var(--list-item-bghover);
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message .document-file-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 20px;
  max-width: 95%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message > * {
  margin-left: 0;
}
.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .file-properties {
  color: var(--chat-text-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/mediaViewer/MediaSearchFiles.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".media-search-files[data-v-25cb42be] {\n  height: 100%;\n  overflow-y: auto;\n}\n.media-search-files[data-v-25cb42be] > :last-child {\n  margin-bottom: 20px;\n}\n.media-search-files .months-name[data-v-25cb42be] {\n  display: flex;\n  justify-content: center;\n  font-weight: 500;\n  margin: 8px auto;\n}\n.media-search-files .files-wrapper[data-v-25cb42be] {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] {\n  margin-left: 4px;\n  margin-right: 4px;\n  margin-bottom: 16px;\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message {\n  display: grid;\n  grid-template-columns: 50px minmax(50px, auto);\n  padding-top: 0px;\n  height: 48px;\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message:hover {\n  background-color: var(--list-item-bghover);\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message .document-file-name {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 20px;\n  max-width: 95%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .chat-document-file-message > * {\n  margin-left: 0;\n}\n.media-search-files .files-wrapper .media-file-search[data-v-25cb42be] .file-properties {\n  color: var(--chat-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
